import LoaderSection from './LoaderSection/LoaderSection';
import LoadingPage from './LoadingPage';

export default {
  Section: LoaderSection,
  Page: LoadingPage,
};
